// extracted by mini-css-extract-plugin
export default {"container":"zY-z","title":"AY-z","link":"BY-z"};